(function () {
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function initAccordionAnimation(root) {
    root.querySelectorAll('.cc-accordion-item').forEach(function (item) {
      var summary = item.querySelector(':scope > summary');
      if (!summary || summary.dataset.faqBound) return;
      summary.dataset.faqBound = 'true';
      summary.addEventListener('click', function (evt) {
        evt.preventDefault();
        var panel = item.querySelector(':scope > .cc-accordion-item__panel');
        var isOpen = item.hasAttribute('open');
        var group = item.closest('.cc-accordion');
        var allowMulti = group && group.getAttribute('data-allow-multi-open') === 'true';

        if (!allowMulti && group) {
          group.querySelectorAll('.cc-accordion-item[open]').forEach(function (openItem) {
            if (openItem !== item) {
              openItem.classList.add('is-closing');
              openItem.classList.remove('is-open');
              window.setTimeout(function () {
                openItem.removeAttribute('open');
                openItem.classList.remove('is-closing');
              }, 300);
            }
          });
        }

        if (isOpen) {
          item.classList.add('is-closing');
          item.classList.remove('is-open');
          window.setTimeout(function () {
            item.removeAttribute('open');
            item.classList.remove('is-closing');
          }, 300);
        } else {
          item.setAttribute('open', '');
          requestAnimationFrame(function () {
            item.classList.add('is-open');
          });
        }
      });
    });
  }

  function initFaqHeader(container) {
    var searchInput = container.querySelector('.faq-search__input');
    var indexContainer = container.querySelector('.faq-index__item-container');
    var stickyContainer = container.querySelector('.faq-index__sticky-container');
    var linkedQuestionContainers = [];
    var linkedContent = [];
    var lastLinkedSection = null;

    function buildIndex() {
      if (indexContainer) {
        indexContainer.querySelectorAll('.faq-index-item').forEach(function (el) {
          el.parentNode.removeChild(el);
        });
      }
      linkedQuestionContainers = [];
      linkedContent = [];
      lastLinkedSection = null;

      var faqHeaderSection = container.closest('.section-faq-header');
      if (!faqHeaderSection) return;

      var current = faqHeaderSection;
      while (current.nextElementSibling && current.nextElementSibling.classList.contains('section-collapsible-tabs')) {
        current = current.nextElementSibling;
        lastLinkedSection = current;

        current.querySelectorAll('.collapsible-tabs__tab').forEach(function (el) {
          linkedQuestionContainers.push(el);
        });
        current.querySelectorAll('.collapsible-tabs__content').forEach(function (el) {
          linkedContent.push(el);
        });

        if (indexContainer) {
          var heading = current.querySelector('.collapsible-tabs__heading');
          if (heading) {
            var link = document.createElement('div');
            link.className = 'faq-index-item';
            link.innerHTML = '<a class="faq-index-item__link" href="#' + heading.id + '">' + heading.innerHTML + '</a>';
            indexContainer.appendChild(link);
          }
        }
      }

      resizeIndex();
    }

    function resizeIndex() {
      if (!stickyContainer || !lastLinkedSection) return;
      var stickyRect = stickyContainer.getBoundingClientRect();
      var lastRect = lastLinkedSection.getBoundingClientRect();
      var height = lastRect.bottom - stickyRect.top;
      if (height > 0) {
        stickyContainer.style.height = height + 'px';
      }
    }

    function performSearch() {
      var terms = searchInput.value
        .split(' ')
        .map(function (t) { return t.trim().toLowerCase(); })
        .filter(function (t) { return t.length > 0; });

      linkedQuestionContainers.forEach(function (el) {
        if (terms.length) {
          var text = el.textContent.toLowerCase();
          var found = terms.some(function (term) { return text.indexOf(term) >= 0; });
          el.classList.toggle('faq-search-item-inactive', !found);
        } else {
          el.classList.remove('faq-search-item-inactive');
        }
      });

      linkedContent.forEach(function (el) {
        el.classList.toggle('faq-search-item-inactive', terms.length > 0);
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', debounce(performSearch, 10));
    }

    if (indexContainer) {
      container.addEventListener('click', function (evt) {
        if (evt.target.classList.contains('faq-index-item__link')) {
          evt.preventDefault();
          var id = evt.target.getAttribute('href').split('#')[1];
          var target = document.getElementById(id);
          if (target) {
            var top = target.getBoundingClientRect().top + window.pageYOffset - 50;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        }
      });
    }

    buildIndex();

    if (indexContainer) {
      window.addEventListener('resize', debounce(resizeIndex, 250));
      // Accordion open/close changes the page's total height, which shifts
      // where the sticky sidebar should stop scrolling — recompute then too.
      container.addEventListener('click', function (evt) {
        if (evt.target.closest && evt.target.closest('.cc-accordion-item__title')) {
          window.setTimeout(resizeIndex, 320);
        }
      });
    }

    // Bind accordion open/close animation on all linked collapsible-tabs sections
    var faqHeaderSection = container.closest('.section-faq-header');
    if (faqHeaderSection) {
      var current = faqHeaderSection;
      while (current.nextElementSibling && current.nextElementSibling.classList.contains('section-collapsible-tabs')) {
        current = current.nextElementSibling;
        initAccordionAnimation(current);
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-section-type="faq-header"]').forEach(initFaqHeader);
    // Also bind accordion animation for any collapsible-tabs not preceded by a faq-header
    document.querySelectorAll('[data-section-type="collapsible-tabs"]').forEach(function (el) {
      initAccordionAnimation(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
